import { Controller } from "stimulus"

export default class extends Controller {
  checkAutoPriceWithoutClient () {
    if ($('global_price_inc_tax_setting').value == 'auto' && $('document_client_id').value == '') {
      confirm = new Fakturan.Alert({
        content: I18n.load('auto_prices_but_no_client_alert')
      });
      confirm.show()
    }
  }
}